export default [
  {
    title: "Merchant Report",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Merchant Report List",
        route: "custom-module",
        path: "/custom-module/merchantreport",
      },
    ],
  },
];
